// extracted by mini-css-extract-plugin
module.exports = {"image":"style_image__105de","light-box-image":"style_light-box-image__9ALR6"};